import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { GlobalVars } from '../../app/app.environment';
import { PetitionProvider } from '../../providers/petition/petition';


@IonicPage()
@Component({
  selector: 'page-petitions-state',
  templateUrl: 'petitions-state.html',
})
export class PetitionsStatePage {

  public areas: Array<any> = [];
  public areasRef;
  public missatges: Array<any> = [];
  public peticionsVacancesRef;

  public loading;

  petitions;
  
  constructor(
    public globalVars: GlobalVars,
    public toast: ToastController,
    public loadingCtrl: LoadingController, 
    public navCtrl: NavController, 
    public navParams: NavParams,
    public petitionProvider: PetitionProvider,
  ) {      
    this.petitions = petitionProvider.getUserPetitionsState()
  }

  info(petition) {
    this.navCtrl.push('PetitionInfoPage', { mode:'mailbox', petition: petition});
  }
}



// WEBPACK FOOTER //
// ./src/pages/petitions-state/petitions-state.ts